














































import Vue from 'vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
export default Vue.extend({
  props: {
    getResult: {
      type: Boolean,
    },
    csvData: {
      type: Object,
    },
  },
  components: {
    NotificationText,
  },
  data(): {
    error: boolean;
    isColumnSelected: boolean[];
  } {
    return {
      error: false,
      isColumnSelected: [],
    };
  },
  created() {
    this.isColumnSelected = this.csvData.columns.map(() => false);
  },
  methods: {
    onClickNextButton() {
      console.log('here');
      if (
        !this.isColumnSelected.reduce((acc, x) => {
          console.log(x);
          if (x) {
            return true;
          }
          return acc;
        }, false)
      ) {
        this.error = true;
      }

      let payload = {
        ok: !this.error,
        exampleData: [''],
        parsing_rule: {
          properties: [''],
        },
      };

      payload.exampleData = this.csvData.values.map(
        (value: string, idx: number) => {
          if (this.isColumnSelected[idx]) {
            return value;
          }
          return '';
        },
      );

      payload['parsing_rule'].properties = this.csvData.columns.map(
        (columnName: string, idx: number) => {
          if (this.isColumnSelected[idx]) {
            return columnName;
          }
          return '';
        },
      );

      this.$emit('pushResult', payload);
    },
    onClickTable(e: Event) {
      const clickedIndex = parseInt(
        (e.target as HTMLElement).dataset.idx as string,
      );

      this.isColumnSelected = this.isColumnSelected.map(
        (isIdxSelected, idx) => {
          if (idx == clickedIndex) {
            return !isIdxSelected;
          }
          return isIdxSelected;
        },
      );

      e.stopPropagation();
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
